import React from 'react';

function Info(props: object) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.3125C13.0386 16.3125 16.3125 13.0386 16.3125 9C16.3125 4.96142 13.0386 1.6875 9 1.6875C4.96142 1.6875 1.6875 4.96142 1.6875 9C1.6875 13.0386 4.96142 16.3125 9 16.3125ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02943 13.9706 0 9 0C4.02943 0 0 4.02943 0 9C0 13.9706 4.02943 18 9 18ZM7.03125 7.875H7.875H8.71874C9.34005 7.875 9.84374 8.37868 9.84374 9V12.9375V13.7812H8.15624V12.9375V9.5625H7.875H7.03125V7.875ZM9 6.75C9.62133 6.75 10.125 6.24632 10.125 5.625C10.125 5.00368 9.62133 4.5 9 4.5C8.37868 4.5 7.875 5.00368 7.875 5.625C7.875 6.24632 8.37868 6.75 9 6.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Info;
